import { useQuery } from "@tanstack/react-query";
import { format } from "date-fns";
import { useSelector } from "react-redux";
import ApiService from "../../services/ApiService";

/**
 * Best-performing posts from tracked accounts, sourced from ClickHouse
 * (tracked_post_stats). Returns posts in the same shape BestPostsCards renders
 * for earned/owned posts, so they can be merged into a single sorted list.
 */
const useTrackedBestPosts = (sorting, { sponsorObjectId, rightsholderId, parentTenantId, partnerId, enabled = true } = {}) => {
  const tenant = useSelector((state) => state.auth.tenant);
  const date = useSelector((state) => state.date);
  const { startDate, endDate } = date;
  const hasDates = !!(startDate && endDate);
  let since;
  let until;
  if (hasDates) {
    since = format(new Date(startDate), "yyyy-MM-dd");
    until = format(new Date(endDate), "yyyy-MM-dd");
  }

  return useQuery({
    queryKey: [
      "TRACKED_BEST_POSTS",
      tenant.id,
      sponsorObjectId,
      rightsholderId,
      parentTenantId,
      partnerId,
      `${sorting.order ? "-" : ""}${sorting.value}`,
      startDate,
      endDate,
    ],
    queryFn: () => ApiService.getPerformingTrackedPosts({
      since,
      until,
      orderBy: sorting.value,
      orderDirection: sorting.order ? "asc" : "desc",
      sponsorObjectId: sponsorObjectId || undefined,
      rightsholderId: rightsholderId || undefined,
      parentTenantId: parentTenantId || undefined,
      partnerId: partnerId || undefined,
      limit: 12,
    }),
    select: (res) => ({ posts: res.data?.posts ?? [] }),
    enabled: hasDates && enabled,
    placeholderData: { data: { posts: [] } },
    staleTime: 30 * 1000,
  });
};

export default useTrackedBestPosts;
